<template>
  <v-form>
    <v-row>
      <v-col cols="6">
        <v-text-field
          autocomplete="off"
          type="text"
          name="productName"
          hide-details
          outlined
          dense
          label="Product Name"
          v-model="record.Name"
        ></v-text-field>
      </v-col>

      <v-col cols="3">
        <v-autocomplete
          name="productCategoryCreate"
          hide-details
          dense
          outlined
          v-model="record.i_t_m1_s_id"
          :items="categories"
          label="Category"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="3">
        <v-autocomplete
          autocomplete="off"
          hide-details
          dense
          outlined
          v-model="record.brand_id"
          :items="brands"
          label="Company / Brand"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="3">
        <v-autocomplete
          autocomplete="off"
          outlined
          dense
          v-model="record.UgpEntry"
          @change="CheckUoMGroup(record.UgpEntry)"
          :items="ougp"
          item-text="UgpName"
          item-value="id"
          label="UoM Group"
        ></v-autocomplete>
      </v-col>

      <!-- <v-col cols="3">
        <v-text-field hide-details outlined dense label="Buying Price(custom)" v-model="record.BuyingPrice"></v-text-field>
      </v-col>-->

      <v-col
        cols="3"
        v-show="docCreate == true"
      >
        <v-text-field
          autocomplete="off"
          type="text"
          hide-details
          outlined
          dense
          label="Selling Price"
          v-model="record.SellingPrice"
        ></v-text-field>
      </v-col>

      <v-col
        cols="3"
        v-show="showPricing == true"
      >
        <v-autocomplete
          autocomplete="off"
          outlined
          dense
          @change="setSVolume(PriceUnit)"
          v-model="record.PriceUnit"
          :items="uoms"
          item-text="uomentry.UomName"
          item-value="uomentry.id"
          label="Pricing Unit"
        ></v-autocomplete>
      </v-col>

      <v-col cols="3">
        <v-autocomplete
          autocomplete="off"
          outlined
          dense
          v-model="record.ItemType"
          :items="itemTypes"
          item-text="name"
          item-value="value"
          label="Item Type"
        ></v-autocomplete>
        <span style="color: red">(Only change if not a stock item)</span>
      </v-col>

      <v-col cols="3">
        <v-text-field
          autocomplete="off"
          type="text"
          hide-details
          outlined
          dense
          label="Re Order Level"
          v-model="record.ReOrder"
        ></v-text-field>
      </v-col>

      <v-col
        cols="12"
        xs="12"
        md="3"
      >
        <v-radio-group
          dense
          label="Taxable"
          v-model="record.Taxable"
          row
        >
          <v-radio
            label="Yes"
            value="Y"
          ></v-radio>
          <v-radio
            label="No"
            value="N"
          ></v-radio>
        </v-radio-group>
      </v-col>

      <v-col
        cols="12"
        md="3"
      >
        <v-autocomplete
          autocomplete="off"
          outlined
          dense
          v-model="record.CardCode"
          :items="vendors"
          item-text="Name"
          item-value="id"
          label="Preffered Vendor"
        ></v-autocomplete>

      </v-col>

      <!-- <v-col cols="3">
        <v-text-field dense outlined v-model="record.BuyingPrice" label="Buying Price(custom)"></v-text-field>
      </v-col>-->
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-tabs background-color="tabToolbar">
          <v-tab>Purchasing Data</v-tab>
          <v-tab>Sales Data</v-tab>
          <v-tab>Inventory Data</v-tab>
          <!-- v-tab-items -->

          <!-- general -->
          <v-tab-item>
            <v-row>
              <v-col
                cols="3"
                v-show="manualStatus == false"
              >
                <v-autocomplete
                  name="productPurchaseUom"
                  outlined
                  dense
                  v-model="record.PUoMEntry"
                  @change="setBuyUnitMsr(record.PUoMEntry)"
                  :items="uoms"
                  item-text="uomentry.UomName"
                  item-value="uomentry.id"
                  label="Purchasing UOM"
                ></v-autocomplete>
              </v-col>

              <v-col cols="3">
                <v-text-field
                  name="NumInBuy"
                  readonly
                  filled
                  hide-details
                  outlined
                  dense
                  label="Items Per Purchasing unit"
                  v-model="record.NumInBuy"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item>
            <v-row>
              <v-col
                cols="3"
                v-show="manualStatus == false"
              >
                <v-autocomplete
                  name="SUoMEntry"
                  dense
                  outlined
                  v-model="record.SUoMEntry"
                  @change="setSalUnitMsr(record.SUoMEntry)"
                  :items="uoms"
                  item-text="uomentry.UomName"
                  item-value="uomentry.id"
                  label="Sales UOM Code"
                ></v-autocomplete>
              </v-col>

              <v-col cols="3">
                <v-text-field
                  name="NumInSale"
                  filled
                  readonly
                  hide-details
                  outlined
                  dense
                  label="Items Per Sales unit"
                  v-model="record.NumInSale"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item>
            <v-row>
              <v-col
                cols="3"
                v-show="manualStatus == false"
              >
                <v-autocomplete
                  name="IUoMEntry"
                  outlined
                  dense
                  v-model="record.IUoMEntry"
                  @change="setInvntryUom(record.IUoMEntry)"
                  :items="uoms"
                  item-text="uomentry.UomName"
                  item-value="uomentry.id"
                  label="UOM Code"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-btn
          v-if="docCreate == true"
          color="accent"
          @click="sendData"
          :loading="loader"
        >
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>

        <v-btn
          v-else
          color="accent"
          @click="updateData"
          :loading="loader"
        >
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-form>
</template>


<script>
export default {
  name: "ProductsEditor",
  props: {
    initial: {
      type: Object,
      required: true,
    },
    docCreate: {
      type: Boolean,
    },
  },
  data: () => ({
    record: {},
    loader: false,
    PriceUnit: null,
    categories: [],
    industries: [],
    showPricing: false,
    manualStatus: false,
    uoms: [],
    ougp: [],
    brands: [],
    stores: [],
    vendors: [],
    store: null,
    date: new Date().toISOString().substr(0, 10),
    itemTypes: [
      { name: "Inventory", value: "I" },
      { name: "Service Item", value: "S" },
      { name: "Delivery Charges", value: "C" },
    ],
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      if (this.docCreate == false) {
        if (val.ugpentry) {
          const manualType = val.ugpentry.IsManual;
          if (manualType == "Y") {
            this.showPricing = false;
            this.manualStatus = true;
          } else {
            this.showPricing = true;
            this.manualStatus = false;
            // get uom group uoms
            const self = this;
            this.$store
              .dispatch("get", `/ougp/${val.UgpEntry}`)
              .then((res) => {
                self.uoms = res.ResponseData.groupDef;
              })
              .catch((err) => {
                this.$refs.snackbar.show(err, "red");
              });
            // end
          }
        }
      }

      this.record = { ...val };
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      if (this.record.ItemType == null || this.record.ItemType == undefined) {
        this.$refs.snackbar.show("Please select Item Type!", "red");
      } else {
        if (
          this.record.SellingPrice !== undefined ||
          this.record.SellingPrice !== undefined
        ) {
          this.loader = true;
          this.$emit("data", this.record);
        } else {
          this.$refs.snackbar.show(
            "Product Name or selling price missing!",
            "red"
          );
        }
      }
    },
    updateData() {
      this.loader = true;
      this.$emit("data", this.record);
    },
    setSVolume(id) {
      const data = this.uoms.find((record) => {
        return record.UomEntry === id;
      });
      this.record.SVolume = data.BaseQty;
    },
    setSalUnitMsr(id) {
      const data = this.uoms.find((record) => {
        return record.UomEntry === id;
      });
      this.record.NumInSale = data.BaseQty;
    },
    setInvntryUom(id) {
      const data = this.uoms.find((record) => {
        return record.UomEntry === id;
      });
      this.record.NumInCnt = data.BaseQty;
    },
    setBuyUnitMsr(id) {
      const data = this.uoms.find((record) => {
        return record.UomEntry === id;
      });
      this.record.NumInBuy = data.BaseQty;
    },
    CheckUoMGroup(id) {
      const uomGroup = this.ougp.find((record) => {
        return record.id === id;
      });
      const self = this;
      if (uomGroup.UgpName === "Manual") {
        self.showPricing = false;
        self.manualStatus = true;
      } else {
        this.loading = true;
        this.$store
          .dispatch("get", `/ougp/${id}`)
          .then((res) => {
            self.uoms = res.ResponseData.groupDef;
            self.showPricing = true;
            self.manualStatus = false;
            self.record.SalUnitMsr = null;
            self.loading = false;
          })
          .catch((err) => {
            this.$refs.snackbar.show(err, "red");
          });
      }
    },
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/products-categories`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.categories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getIndustries() {
      const self = this;
      this.$store
        .dispatch("get", `/industries`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.industries = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getBrands() {
      const self = this;
      this.$store
        .dispatch("get", `/brands`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.brands = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getOugp() {
      const self = this;
      this.$store
        .dispatch("get", `/ougp`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.ougp = res.ResponseData;
            // self.record = { ...self.record, UgpEntry: res.ResponseData[0].id };
            if (self.docCreate == true) {
              self.record.UgpEntry = res.ResponseData[0].id;
              self.record.NumInBuy = 1;
              self.record.NumInSale = 1;
              self.record.NumInBuy = 1;
              // end
              self.showPricing = false;
              self.manualStatus = true;
            }
            // set items per msr
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGeneralSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            // set default store
            if (self.docCreate == true) {
              self.store = res.ResponseData.store_id;
            }
            // set default category
            if (self.record.i_t_m1_s_id == undefined) {
              const brandId = res.ResponseData.defaultBrand;
              const categoryId = res.ResponseData.defaultCategory;
              self.record = {
                ...self.record,
                i_t_m1_s_id: categoryId,
                brand_id: brandId,
              };
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getSuppliers() {
      const self = this;
      this.$store
        .dispatch("get", `/suppliers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.vendors = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getCategories();
    this.getBrands();
    this.getIndustries();
    this.getStores();
    this.getGeneralSettings();
    this.getOugp();
    this.getSuppliers();
  },
};
</script>